const turkishCharacters = { ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u' };
export const normalizeSearch = (value) => value.toLocaleLowerCase('tr-TR')
  .replace(/[çğıöşü]/g, (character) => turkishCharacters[character]);

export const projectComparators = {
  big: (first, second) => second.areaM2 - first.areaM2,
  small: (first, second) => first.areaM2 - second.areaM2,
  new: (first, second) => second.year - first.year,
  old: (first, second) => first.year - second.year,
};

export const filterProjects = (items, category, search, sort) => {
  const query = normalizeSearch(search.trim());
  const matching = items.filter((project) => {
    const matchesCategory = category === 'Tumu' || project.category === category;
    const matchesSearch = [project.title, project.location, project.category]
      .some((value) => normalizeSearch(value).includes(query));
    return matchesCategory && matchesSearch;
  });
  return matching.sort(projectComparators[sort] || projectComparators.big);
};